import React, { useEffect, useState } from "react";
import { Button } from "react-bootstrap";

import travelingImg from "./Images/TravelingImg.png";
import heroImg2 from "./Images/heroImg2.png";
import heroImg3 from "./Images/heroImg3.png";
import heroImg4 from "./Images/heroImg4.png";
import heroImg5 from "./Images/heroImg5.png";
import heroImg6 from "./Images/heroImg6.png";

import newspaperImg from "./Images/E-NEWS.png";
import newspaperIcon from "./Images/NEWSICON.png";

import cabImg from "./Images/cab.png";
import cabIcon from "./Images/CAB_ICON.png";

import bankingImg from "./Images/banking.png";
import bankingIcon from "./Images/BANK ICON.png";

import electryCityImg from "./Images/Electricity.png";
import electrycityicon from "./Images/ELECTRICITY ICON.png";

import telecomImg from "./Images/telcom.png";
import telecomIcon from "./Images/TELECOM_ICON.png";

import educationImg from "./Images/educationImg.png";
import educationIcon from "./Images/EDUCATION_ICON.png";

import carInsuranceImg from "./Images/Car Insurance.png";
import carInsuranceIcon from "./Images/CARINSURANCE_ICON.png";

import broadcastImg from "./Images/broadcast.png";
import broadcastIcon from "./Images/BROADCAST ICON.png";

import electionImg from "./Images/Election Duty.png";
import electionIcon from "./Images/ELECTION_ICON.png";

import foodImg from "./Images/foodImg.png";
import foodIcon from "./Images/FOOD_ICON.png";

import homeImg from "./Images/homeImg.png";
import homeIcon from "./Images/HOME_ICON.png";

import healtcareImg from "./Images/healthcareImg.png";
import healtcareIcon from "./Images/HEALTHCARE_ICON.png";

import ptaImg from "./Images/PTA.png";
import ptaIcon from "./Images/PTA_ICON.png";

import movieImg from "./Images/Movie.png";
import movieIcon from "./Images/MOVIE_ICON.png";

/* buttons */
import button1 from "./Images/b1.png";
import button2 from "./Images/b2.png";
import button3 from "./Images/b3.png";
import button4 from "./Images/b4.png";
import button5 from "./Images/b5.png";
import button6 from "./Images/b6.png";
import button7 from "./Images/b7.png";
import button8 from "./Images/b8.png";
import button9 from "./Images/b9.png";
import button10 from "./Images/b10.png";
import button11 from "./Images/b11.png";

/* day phase icons (right side of slot) */
import morningIcon from "./Images/morning_Icon.png";
import afternoonIcon from "./Images/afternoon.png";
import nightIcon from "./Images/night.png";

/* right side image */
import rightImg from "./Images/rightImgae.png";

const HeroSection = () => {
  const [headRevealed, setHeadRevealed] = useState(false);
  const [showSides, setShowSides] = useState(false); // left card + hero-art + right image

  // slideshow positions
  const [imgStage, setImgStage] = useState(0);
  const [cycleIndex, setCycleIndex] = useState(0); // 0..14

  // left card selection
  const [selectedPhase, setSelectedPhase] = useState(0); // 0=Morning,1=Afternoon,2=Evening
  const [selectedSlot, setSelectedSlot] = useState(0); // 0..4 within phase

  // heartbeat flags (spring bounce)
  const [hbMain, setHbMain] = useState(false); // main service image
  const [hbFront, setHbFront] = useState(false); // heroImg2 (phone)
  const [hbCenter, setHbCenter] = useState(false); // center badge
  const [hbBtn, setHbBtn] = useState(false); // (we don't kick)
  const [hbL5, setHbL5] = useState(false); // heroImg5
  const [hbL4, setHbL4] = useState(false); // heroImg4
  const [hbL3, setHbL3] = useState(false); // heroImg3

  // CHANGED: center badge/button ko delay se show/lock karne ke liye gate
  const [centerGate, setCenterGate] = useState(false);

  /* ===================== TIMINGS ===================== */
  const HEAD_FADE_MS = 600; // header transition duration
  const SIDES_EXTRA_DELAY = 300; // CHANGED: header done + 0.3s → sides fade-in

  const HEARTBEAT_MS = 600; // one bounce

  // First-of-phase (7/12/5) choreography
  const MAIN_TO_PHONE_MS = 500; // heroImg2 after main
  const CENTER_AFTER_MAIN_FIRST_MS = 900; // center+button after phone (phone @500, center @900)
  const CENTER_TO_L5_MS = 300; // center → L5 gap
  const L5_TO_L4_MS = 300; // L5 → L4 gap
  const L4_TO_L3_MS = 300; // L4 → L3 gap
  const AFTER_FIRST_TO_NEXT_MS = 200; // settle edge before moving next

  // Subsequent slots (8,9,10,11 etc.)
  const CENTER_AFTER_MAIN_NEXT_MS = 500; // icon+button 0.5s after main
  const AFTER_NEXT_TO_NEXT_MS = 900; // pause before move next

  const PHASE_SIZE = 5;
  const PHASE_GAP_MS = 700; // (kept if needed later)

  const phaseIcons = [morningIcon, afternoonIcon, nightIcon];

  const phaseDefs = [
    { name: "Morning", period: "AM", slots: ["07", "08", "09", "10", "11"] },
    { name: "Afternoon", period: "PM", slots: ["12", "01", "02", "03", "04"] },
    { name: "Evening", period: "PM", slots: ["05", "06", "07", "08", "09"] },
  ];
  const currentPhase = phaseDefs[selectedPhase];

  // service cycles (15)
  const imageCycles = [
    { mainImg: newspaperImg, centerIcon: newspaperIcon },
    { mainImg: travelingImg, centerIcon: heroImg6 },
    { mainImg: cabImg, centerIcon: cabIcon },
    { mainImg: bankingImg, centerIcon: bankingIcon },
    { mainImg: electryCityImg, centerIcon: electrycityicon },
    { mainImg: telecomImg, centerIcon: telecomIcon },
    { mainImg: educationImg, centerIcon: educationIcon },
    { mainImg: carInsuranceImg, centerIcon: carInsuranceIcon },
    { mainImg: broadcastImg, centerIcon: broadcastIcon },
    { mainImg: electionImg, centerIcon: electionIcon },
    { mainImg: foodImg, centerIcon: foodIcon },
    { mainImg: homeImg, centerIcon: homeIcon },
    { mainImg: healtcareImg, centerIcon: healtcareIcon },
    { mainImg: ptaImg, centerIcon: ptaIcon },
    { mainImg: movieImg, centerIcon: movieIcon },
  ];

  const buttonForCycle = [
    button1, // newspaperIcon
    button2, // heroImg6
    button2, // cabIcon
    button3, // bankingIcon
    button4, // electricity
    button1, // telecom
    button1, // education
    button7, // car insurance
    button7, // broadcast
    button10, // election
    button6, // food
    button5, // home
    button8, // healthcare
    button11, // pta
    button2, // movie
  ];

  // heading fade
  useEffect(() => {
    const h = setTimeout(() => setHeadRevealed(true), 50);
    return () => clearTimeout(h);
  }, []);

  // CHANGED: heading finishes fading → +0.3s → show left/right/art together
  useEffect(() => {
    if (!headRevealed) return;
    const t = setTimeout(
      () => setShowSides(true),
      HEAD_FADE_MS + SIDES_EXTRA_DELAY
    );
    return () => clearTimeout(t);
  }, [headRevealed]);

  // util to restart heartbeat animation
  const kick = (setter) => {
    setter(false);
    requestAnimationFrame(() => {
      setter(true);
      setTimeout(() => setter(false), HEARTBEAT_MS);
    });
  };

  // Is this the 1st slot of a phase? (7AM / 12PM / 5PM)
  // const firstOfPhase = cycleIndex % PHASE_SIZE === 0;  

  const slotWithinPhase = cycleIndex % PHASE_SIZE;
  const phaseIndex = Math.floor(cycleIndex / PHASE_SIZE);

  // Sirf morning ka pehla slot (7AM) full choreography use kare.
  // Baaki sab (including 12PM & 5PM) "8AM pattern" wale branch me jayenge.
  const firstOfPhase = phaseIndex === 0 && slotWithinPhase === 0;

  // ====== Sequencing for all slots ======
  useEffect(() => {
    const timers = [];
    const at = (ms, fn) => timers.push(setTimeout(fn, ms));

    // CHANGED: center ko hamesha reset karo jab naya slot start
    setCenterGate(false);
    setImgStage(0);

    if (firstOfPhase) {
      // 7:00 / 12:00 / 5:00 — full chain
      at(0, () => {
        setImgStage(1);
        kick(setHbMain);
      }); // main (hb)
      at(MAIN_TO_PHONE_MS, () => {
        setImgStage(2);
        kick(setHbFront);
      }); // phone (hb)

      at(CENTER_AFTER_MAIN_FIRST_MS, () => {
        // +0.4s after phone
        setCenterGate(true); // CHANGED: center/button allowed to show
        setImgStage(3);
        kick(setHbCenter); // icon heartbeat
        // button normal (NO kick)
      });

      at(CENTER_AFTER_MAIN_FIRST_MS + CENTER_TO_L5_MS, () => {
        setImgStage(4);
        kick(setHbL5);
      }); // heroImg5
      at(CENTER_AFTER_MAIN_FIRST_MS + CENTER_TO_L5_MS + L5_TO_L4_MS, () => {
        setImgStage(5);
        kick(setHbL4);
      }); // heroImg4
      at(
        CENTER_AFTER_MAIN_FIRST_MS +
        CENTER_TO_L5_MS +
        L5_TO_L4_MS +
        L4_TO_L3_MS,
        () => {
          setImgStage(6);
          kick(setHbL3);
        }
      ); // heroImg3

      const lastTick =
        CENTER_AFTER_MAIN_FIRST_MS +
        CENTER_TO_L5_MS +
        L5_TO_L4_MS +
        L4_TO_L3_MS;
      at(lastTick + HEARTBEAT_MS + AFTER_FIRST_TO_NEXT_MS, () =>
        setCycleIndex(cycleIndex + 1)
      );
    } else {
      // 8:00+ pattern (all subsequent slots)
      // CHANGED: side layers + phone stable
      at(0, () => setImgStage(6)); // badges visible immediately (no jump)
      // CHANGED: main swap turant new image + heartbeat (NO previous flash)
      at(0, () => {
        kick(setHbMain);
        setImgStage(6);
      });

      // CHANGED: center/icon ko gated delay se dikhana
      at(CENTER_AFTER_MAIN_NEXT_MS, () => {
        setCenterGate(true); // ab center/button show honge
        setImgStage(7);
        kick(setHbCenter);
      });

      at(CENTER_AFTER_MAIN_NEXT_MS + HEARTBEAT_MS + AFTER_NEXT_TO_NEXT_MS, () =>
        setCycleIndex((cycleIndex + 1) % imageCycles.length)
      );
    }

    return () => timers.forEach(clearTimeout);
  }, [cycleIndex, firstOfPhase]);

  // keep left card highlight synced
  useEffect(() => {
    setSelectedPhase(Math.floor(cycleIndex / PHASE_SIZE));
    setSelectedSlot(cycleIndex % PHASE_SIZE);
  }, [cycleIndex]);

  // bg like stripe

  useEffect(() => {
    // ---------- Utils ----------
    function normalizeColor(hexCode) {
      return [
        ((hexCode >> 16) & 255) / 255,
        ((hexCode >> 8) & 255) / 255,
        (hexCode & 255) / 255,
      ];
    }
    ["SCREEN", "LINEAR_LIGHT"].reduce(
      (hexCode, t, n) => Object.assign(hexCode, { [t]: n }),
      {}
    );

    // ---------- MiniGl (WebGL helper) ----------
    class MiniGl {
      constructor(canvas, width, height, debug = false) {
        const _miniGl = this;
        const debug_output =
          -1 !== document.location.search.toLowerCase().indexOf("debug=webgl");

        _miniGl.canvas = canvas;
        _miniGl.gl = _miniGl.canvas.getContext("webgl", { antialias: true });
        _miniGl.meshes = [];
        const context = _miniGl.gl;

        width && height && this.setSize(width, height);

        _miniGl.lastDebugMsg = _miniGl.lastDebugMsg ?? null;
        _miniGl.debug =
          debug && debug_output
            ? function (e) {
              const t = new Date();
              t - _miniGl.lastDebugMsg > 1000 && console.log("---");
              console.log(
                t.toLocaleTimeString() +
                Array(Math.max(0, 32 - e.length)).join(" ") +
                e +
                ": ",
                ...Array.from(arguments).slice(1)
              );
              _miniGl.lastDebugMsg = t;
            }
            : () => { };

        Object.defineProperties(_miniGl, {
          Material: {
            enumerable: false,
            value: class {
              constructor(vertexShaders, fragments, uniforms = {}) {
                const material = this;
                function getShaderByType(type, source) {
                  const shader = context.createShader(type);
                  context.shaderSource(shader, source);
                  context.compileShader(shader);
                  if (
                    !context.getShaderParameter(shader, context.COMPILE_STATUS)
                  ) {
                    console.error(context.getShaderInfoLog(shader));
                  }
                  _miniGl.debug("Material.compileShaderSource", { source });
                  return shader;
                }
                function getUniformVariableDeclarations(uniforms, type) {
                  return Object.entries(uniforms)
                    .map(([uniform, value]) =>
                      value.getDeclaration(uniform, type)
                    )
                    .join("\n");
                }
                material.uniforms = uniforms;
                material.uniformInstances = [];

                const prefix = `precision highp float;`;
                material.vertexSource = `
                  ${prefix}
                  attribute vec4 position;
                  attribute vec2 uv;
                  attribute vec2 uvNorm;
                  ${getUniformVariableDeclarations(
                  _miniGl.commonUniforms,
                  "vertex"
                )}
                  ${getUniformVariableDeclarations(uniforms, "vertex")}
                  ${vertexShaders}
                `;
                material.Source = `
                  ${prefix}
                  ${getUniformVariableDeclarations(
                  _miniGl.commonUniforms,
                  "fragment"
                )}
                  ${getUniformVariableDeclarations(uniforms, "fragment")}
                  ${fragments}
                `;
                material.vertexShader = getShaderByType(
                  context.VERTEX_SHADER,
                  material.vertexSource
                );
                material.fragmentShader = getShaderByType(
                  context.FRAGMENT_SHADER,
                  material.Source
                );
                material.program = context.createProgram();
                context.attachShader(material.program, material.vertexShader);
                context.attachShader(material.program, material.fragmentShader);
                context.linkProgram(material.program);
                if (
                  !context.getProgramParameter(
                    material.program,
                    context.LINK_STATUS
                  )
                ) {
                  console.error(context.getProgramInfoLog(material.program));
                }
                context.useProgram(material.program);
                material.attachUniforms(void 0, _miniGl.commonUniforms);
                material.attachUniforms(void 0, material.uniforms);
              }
              attachUniforms(name, uniforms) {
                const material = this;
                if (void 0 === name) {
                  Object.entries(uniforms).forEach(([n, uniform]) => {
                    material.attachUniforms(n, uniform);
                  });
                } else if (uniforms.type === "array") {
                  uniforms.value.forEach((uniform, i) =>
                    material.attachUniforms(`${name}[${i}]`, uniform)
                  );
                } else if (uniforms.type === "struct") {
                  Object.entries(uniforms.value).forEach(([uniform, i]) =>
                    material.attachUniforms(`${name}.${uniform}`, i)
                  );
                } else {
                  _miniGl.debug("Material.attachUniforms", {
                    name,
                    uniform: uniforms,
                  });
                  material.uniformInstances.push({
                    uniform: uniforms,
                    location: context.getUniformLocation(
                      material.program,
                      name
                    ),
                  });
                }
              }
            },
          },
          Uniform: {
            enumerable: false,
            value: class {
              constructor(e) {
                this.type = "float";
                Object.assign(this, e);
                this.typeFn =
                  {
                    float: "1f",
                    int: "1i",
                    vec2: "2fv",
                    vec3: "3fv",
                    vec4: "4fv",
                    mat4: "Matrix4fv",
                  }[this.type] || "1f";
                this.update();
              }
              update(value) {
                if (void 0 !== this.value) {
                  context[`uniform${this.typeFn}`](
                    value,
                    this.typeFn.indexOf("Matrix") === 0
                      ? this.transpose
                      : this.value,
                    this.typeFn.indexOf("Matrix") === 0 ? this.value : null
                  );
                }
              }
              getDeclaration(name, type, length) {
                const uniform = this;
                if (uniform.excludeFrom !== type) {
                  if ("array" === uniform.type) {
                    return (
                      uniform.value[0].getDeclaration(
                        name,
                        type,
                        uniform.value.length
                      ) +
                      `\nconst int ${name}_length = ${uniform.value.length};`
                    );
                  }
                  if ("struct" === uniform.type) {
                    let name_no_prefix = name.replace("u_", "");
                    name_no_prefix =
                      name_no_prefix.charAt(0).toUpperCase() +
                      name_no_prefix.slice(1);
                    return (
                      `uniform struct ${name_no_prefix} 
                      {\n` +
                      Object.entries(uniform.value)
                        .map(([n, u]) =>
                          u.getDeclaration(n, type).replace(/^uniform/, "")
                        )
                        .join("") +
                      `\n} ${name}${length > 0 ? `[${length}]` : ""};`
                    );
                  }
                  return `uniform ${uniform.type} ${name}${length > 0 ? `[${length}]` : ""
                    };`;
                }
              }
            },
          },
          PlaneGeometry: {
            enumerable: false,
            value: class {
              constructor(width, height, n, i, orientation) {
                const context = _miniGl.gl;
                context.createBuffer();
                this.attributes = {
                  position: new _miniGl.Attribute({
                    target: context.ARRAY_BUFFER,
                    size: 3,
                  }),
                  uv: new _miniGl.Attribute({
                    target: context.ARRAY_BUFFER,
                    size: 2,
                  }),
                  uvNorm: new _miniGl.Attribute({
                    target: context.ARRAY_BUFFER,
                    size: 2,
                  }),
                  index: new _miniGl.Attribute({
                    target: context.ELEMENT_ARRAY_BUFFER,
                    size: 3,
                    type: context.UNSIGNED_SHORT,
                  }),
                };
                this.setTopology(n, i);
                this.setSize(width, height, orientation);
              }
              setTopology(e = 1, t = 1) {
                const n = this;
                const context = _miniGl.gl;
                n.xSegCount = e;
                n.ySegCount = t;
                n.vertexCount = (n.xSegCount + 1) * (n.ySegCount + 1);
                n.quadCount = n.xSegCount * n.ySegCount * 2;
                n.attributes.uv.values = new Float32Array(2 * n.vertexCount);
                n.attributes.uvNorm.values = new Float32Array(
                  2 * n.vertexCount
                );
                n.attributes.index.values = new Uint16Array(3 * n.quadCount);
                for (let y = 0; y <= n.ySegCount; y++) {
                  for (let x = 0; x <= n.xSegCount; x++) {
                    const i = y * (n.xSegCount + 1) + x;
                    n.attributes.uv.values[2 * i] = x / n.xSegCount;
                    n.attributes.uv.values[2 * i + 1] = 1 - y / n.ySegCount;
                    n.attributes.uvNorm.values[2 * i] =
                      (x / n.xSegCount) * 2 - 1;
                    n.attributes.uvNorm.values[2 * i + 1] =
                      1 - (y / n.ySegCount) * 2;
                    if (x < n.xSegCount && y < n.ySegCount) {
                      const s = y * n.xSegCount + x;
                      n.attributes.index.values[6 * s] = i;
                      n.attributes.index.values[6 * s + 1] =
                        i + 1 + n.xSegCount;
                      n.attributes.index.values[6 * s + 2] = i + 1;
                      n.attributes.index.values[6 * s + 3] = i + 1;
                      n.attributes.index.values[6 * s + 4] =
                        i + 1 + n.xSegCount;
                      n.attributes.index.values[6 * s + 5] =
                        i + 2 + n.xSegCount;
                    }
                  }
                }
                n.attributes.uv.update();
                n.attributes.uvNorm.update();
                n.attributes.index.update();
                _miniGl.debug("Geometry.setTopology", {
                  uv: n.attributes.uv,
                  uvNorm: n.attributes.uvNorm,
                  index: n.attributes.index,
                });
              }
              setSize(width = 1, height = 1, orientation = "xz") {
                const geometry = this;
                const context = _miniGl.gl;
                geometry.width = width;
                geometry.height = height;
                geometry.orientation = orientation;
                if (
                  !geometry.attributes.position.values ||
                  geometry.attributes.position.values.length !==
                  3 * geometry.vertexCount
                ) {
                  geometry.attributes.position.values = new Float32Array(
                    3 * geometry.vertexCount
                  );
                }
                const o = width / -2;
                const r = height / -2;
                const segment_width = width / geometry.xSegCount;
                const segment_height = height / geometry.ySegCount;

                for (let yIndex = 0; yIndex <= geometry.ySegCount; yIndex++) {
                  const t = r + yIndex * segment_height;
                  for (let xIndex = 0; xIndex <= geometry.xSegCount; xIndex++) {
                    const rx = o + xIndex * segment_width;
                    const l = yIndex * (geometry.xSegCount + 1) + xIndex;
                    geometry.attributes.position.values[
                      3 * l + "xyz".indexOf(geometry.orientation[0])
                    ] = rx;
                    geometry.attributes.position.values[
                      3 * l + "xyz".indexOf(geometry.orientation[1])
                    ] = -t;
                  }
                }
                geometry.attributes.position.update();
                _miniGl.debug("Geometry.setSize", {
                  position: geometry.attributes.position,
                });
              }
            },
          },
          Mesh: {
            enumerable: false,
            value: class {
              constructor(geometry, material) {
                const mesh = this;
                const context = _miniGl.gl;
                mesh.geometry = geometry;
                mesh.material = material;
                mesh.wireframe = false;
                mesh.attributeInstances = [];
                Object.entries(mesh.geometry.attributes).forEach(
                  ([e, attribute]) => {
                    mesh.attributeInstances.push({
                      attribute,
                      location: attribute.attach(e, mesh.material.program),
                    });
                  }
                );
                _miniGl.meshes.push(mesh);
                _miniGl.debug("Mesh.constructor", { mesh });
              }
              draw() {
                const context = _miniGl.gl;
                context.useProgram(this.material.program);
                this.material.uniformInstances.forEach(
                  ({ uniform, location }) => uniform.update(location)
                );
                this.attributeInstances.forEach(({ attribute, location }) =>
                  attribute.use(location)
                );
                context.drawElements(
                  this.wireframe ? context.LINES : context.TRIANGLES,
                  this.geometry.attributes.index.values.length,
                  context.UNSIGNED_SHORT,
                  0
                );
              }
              remove() {
                _miniGl.meshes = _miniGl.meshes.filter((e) => e !== this);
              }
            },
          },
          Attribute: {
            enumerable: false,
            value: class {
              constructor(e) {
                const context = _miniGl.gl;
                this.type = context.FLOAT;
                this.normalized = false;
                this.buffer = context.createBuffer();
                Object.assign(this, e);
                this.update();
              }
              update() {
                const context = _miniGl.gl;
                if (void 0 !== this.values) {
                  context.bindBuffer(this.target, this.buffer);
                  context.bufferData(
                    this.target,
                    this.values,
                    context.STATIC_DRAW
                  );
                }
              }
              attach(name, program) {
                const context = _miniGl.gl;
                const loc = context.getAttribLocation(program, name);
                if (this.target === context.ARRAY_BUFFER) {
                  context.enableVertexAttribArray(loc);
                  context.vertexAttribPointer(
                    loc,
                    this.size,
                    this.type,
                    this.normalized,
                    0,
                    0
                  );
                }
                return loc;
              }
              use(loc) {
                const context = _miniGl.gl;
                context.bindBuffer(this.target, this.buffer);
                if (this.target === context.ARRAY_BUFFER) {
                  context.enableVertexAttribArray(loc);
                  context.vertexAttribPointer(
                    loc,
                    this.size,
                    this.type,
                    this.normalized,
                    0,
                    0
                  );
                }
              }
            },
          },
        });

        const a = [1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1];
        _miniGl.commonUniforms = {
          projectionMatrix: new _miniGl.Uniform({ type: "mat4", value: a }),
          modelViewMatrix: new _miniGl.Uniform({ type: "mat4", value: a }),
          resolution: new _miniGl.Uniform({ type: "vec2", value: [1, 1] }),
          aspectRatio: new _miniGl.Uniform({ type: "float", value: 1 }),
        };
      }
      setSize(w = 640, h = 480) {
        this.width = w;
        this.height = h;
        this.canvas.width = w;
        this.canvas.height = h;
        this.gl.viewport(0, 0, w, h);
        this.commonUniforms.resolution.value = [w, h];
        this.commonUniforms.aspectRatio.value = w / h;
        this.debug("MiniGL.setSize", { width: w, height: h });
      }
      setOrthographicCamera(e = 0, t = 0, n = 0, i = -2000, s = 2000) {
        this.commonUniforms.projectionMatrix.value = [
          2 / this.width,
          0,
          0,
          0,
          0,
          2 / this.height,
          0,
          0,
          0,
          0,
          2 / (i - s),
          0,
          e,
          t,
          n,
          1,
        ];
        this.debug(
          "setOrthographicCamera",
          this.commonUniforms.projectionMatrix.value
        );
      }
      render() {
        this.gl.clearColor(0, 0, 0, 0);
        this.gl.clearDepth(1);
        this.meshes.forEach((m) => m.draw());
      }
    }

    // ---------- Helper for property define ----------
    function def(o, k, v) {
      return k in o
        ? Object.defineProperty(o, k, {
          value: v,
          enumerable: true,
          configurable: true,
          writable: true,
        })
        : (o[k] = v);
    }

    // ---------- Gradient ----------
    class Gradient {
      constructor() {
        def(this, "el", void 0);
        def(this, "cssVarRetries", 0);
        def(this, "maxCssVarRetries", 200);
        def(this, "angle", 0);
        def(this, "isLoadedClass", false);
        def(this, "isScrolling", false);
        def(this, "scrollingTimeout", void 0);
        def(this, "scrollingRefreshDelay", 200);
        def(this, "isIntersecting", false);
        def(this, "shaderFiles", void 0);
        def(this, "vertexShader", void 0);
        def(this, "sectionColors", void 0);
        def(this, "computedCanvasStyle", void 0);
        def(this, "conf", void 0);
        def(this, "uniforms", void 0);
        def(this, "t", 1253106);
        def(this, "last", 0);
        def(this, "width", void 0);
        def(this, "minWidth", 1111);
        def(this, "height", 600);
        def(this, "xSegCount", void 0);
        def(this, "ySegCount", void 0);
        def(this, "mesh", void 0);
        def(this, "material", void 0);
        def(this, "geometry", void 0);
        def(this, "minigl", void 0);
        def(this, "scrollObserver", void 0);
        def(this, "amp", 320);
        def(this, "seed", 5);
        def(this, "freqX", 14e-5);
        def(this, "freqY", 29e-5);
        def(this, "freqDelta", 1e-5);
        def(this, "activeColors", [1, 1, 1, 1]);
        def(this, "isMetaKey", false);
        def(this, "isGradientLegendVisible", false);
        def(this, "isMouseDown", false);

        def(this, "handleScroll", () => {
          clearTimeout(this.scrollingTimeout);
          this.scrollingTimeout = setTimeout(
            this.handleScrollEnd,
            this.scrollingRefreshDelay
          );
          this.isGradientLegendVisible && this.hideGradientLegend();
          if (this.conf.playing) {
            this.isScrolling = true;
            this.pause();
          }
        });
        def(this, "handleScrollEnd", () => {
          this.isScrolling = false;
          this.isIntersecting && this.play();
        });
        def(this, "resize", () => {
          this.width = window.innerWidth;
          this.minigl.setSize(this.width, this.height);
          this.minigl.setOrthographicCamera();
          this.xSegCount = Math.ceil(this.width * this.conf.density[0]);
          this.ySegCount = Math.ceil(this.height * this.conf.density[1]);
          this.mesh.geometry.setTopology(this.xSegCount, this.ySegCount);
          this.mesh.geometry.setSize(this.width, this.height);
          this.mesh.material.uniforms.u_shadow_power.value =
            this.width < 600 ? 5 : 6;
        });
        def(this, "handleMouseDown", (e) => {
          if (this.isGradientLegendVisible) {
            this.isMetaKey = e.metaKey;
            this.isMouseDown = true;
            if (this.conf.playing === false)
              requestAnimationFrame(this.animate);
          }
        });
        def(this, "handleMouseUp", () => {
          this.isMouseDown = false;
        });
        def(this, "animate", (e) => {
          if (!this.shouldSkipFrame(e) || this.isMouseDown) {
            this.t += Math.min(e - this.last, 1000 / 15);
            this.last = e;
            if (this.isMouseDown) {
              let d = 160;
              if (this.isMetaKey) d = -160;
              this.t += d;
            }
            this.mesh.material.uniforms.u_time.value = this.t;
            this.minigl.render();
          }
          if (this.last !== 0 && this.isStatic) {
            this.minigl.render();
            this.disconnect();
            return;
          }
          (this.conf.playing || this.isMouseDown) &&
            requestAnimationFrame(this.animate);
        });
        def(this, "addIsLoadedClass", () => {
          if (!this.isLoadedClass) {
            this.isLoadedClass = true;
            this.el.classList.add("isLoaded");
            setTimeout(() => {
              this.el.parentElement &&
                this.el.parentElement.classList.add("isLoaded");
            }, 3000);
          }
        });
        def(this, "pause", () => {
          this.conf.playing = false;
        });
        def(this, "play", () => {
          requestAnimationFrame(this.animate);
          this.conf.playing = true;
        });
        def(this, "initGradient", (selector) => {
          this.el = document.querySelector(selector);
          this.connect();
          return this;
        });
      }
      async connect() {
        this.shaderFiles = {
          vertex: `varying vec3 v_color;

void main() {
  float time = u_time * u_global.noiseSpeed;

  vec2 noiseCoord = resolution * uvNorm * u_global.noiseFreq;

  vec2 st = 1. - uvNorm.xy;

  // Tilting the plane
  float tilt = resolution.y / 2.0 * uvNorm.y;
  float incline = resolution.x * uvNorm.x / 2.0 * u_vertDeform.incline;
  float offset = resolution.x / 2.0 * u_vertDeform.incline * mix(u_vertDeform.offsetBottom, u_vertDeform.offsetTop, uv.y);

  // Vertex noise
  float noise = snoise(vec3(
    noiseCoord.x * u_vertDeform.noiseFreq.x + time * u_vertDeform.noiseFlow,
    noiseCoord.y * u_vertDeform.noiseFreq.y,
    time * u_vertDeform.noiseSpeed + u_vertDeform.noiseSeed
  )) * u_vertDeform.noiseAmp;

  noise *= 1.0 - pow(abs(uvNorm.y), 2.0);
  noise = max(0.0, noise);

  vec3 pos = vec3(
    position.x,
    position.y + tilt + incline + noise - offset,
    position.z
  );

  // Vertex color
  if (u_active_colors[0] == 1.) {
    v_color = u_baseColor;
  }

  for (int i = 0; i < u_waveLayers_length; i++) {
    if (u_active_colors[i + 1] == 1.) {
      WaveLayers layer = u_waveLayers[i];
      float noise = smoothstep(
        layer.noiseFloor,
        layer.noiseCeil,
        snoise(vec3(
          noiseCoord.x * layer.noiseFreq.x + time * layer.noiseFlow,
          noiseCoord.y * layer.noiseFreq.y,
          time * layer.noiseSpeed + layer.noiseSeed
        )) / 2.0 + 0.5
      );
      v_color = blendNormal(v_color, layer.color, pow(noise, 4.));
    }
  }

  gl_Position = projectionMatrix * modelViewMatrix * vec4(pos, 1.0);
}`,
          noise: `// Ashima Arts / Stegu simplex noise (MIT)
vec3 mod289(vec3 x){return x - floor(x * (1.0 / 289.0)) * 289.0;}
vec4 mod289(vec4 x){return x - floor(x * (1.0 / 289.0)) * 289.0;}
vec4 permute(vec4 x){return mod289(((x*34.0)+1.0)*x);}
vec4 taylorInvSqrt(vec4 r){return 1.79284291400159 - 0.85373472095314 * r;}
float snoise(vec3 v){
  const vec2  C = vec2(1.0/6.0, 1.0/3.0) ;
  const vec4  D = vec4(0.0, 0.5, 1.0, 2.0);
  vec3 i  = floor(v + dot(v, C.yyy) );
  vec3 x0 =   v - i + dot(i, C.xxx) ;
  vec3 g = step(x0.yzx, x0.xyz);
  vec3 l = 1.0 - g;
  vec3 i1 = min( g.xyz, l.zxy );
  vec3 i2 = max( g.xyz, l.zxy );
  vec3 x1 = x0 - i1 + C.xxx;
  vec3 x2 = x0 - i2 + C.yyy;
  vec3 x3 = x0 - D.yyy;
  i = mod289(i);
  vec4 p = permute( permute( permute(
            i.z + vec4(0.0, i1.z, i2.z, 1.0 ))
          + i.y + vec4(0.0, i1.y, i2.y, 1.0 ))
          + i.x + vec4(0.0, i1.x, i2.x, 1.0 ));
  float n_ = 0.142857142857;
  vec3  ns = n_ * D.wyz - D.xzx;
  vec4 j = p - 49.0 * floor(p * ns.z * ns.z);
  vec4 x_ = floor(j * ns.z);
  vec4 y_ = floor(j - 7.0 * x_ );
  vec4 x = x_ *ns.x + ns.yyyy;
  vec4 y = y_ *ns.x + ns.yyyy;
  vec4 h = 1.0 - abs(x) - abs(y);
  vec4 b0 = vec4( x.xy, y.xy );
  vec4 b1 = vec4( x.zw, y.zw );
  vec4 s0 = floor(b0)*2.0 + 1.0;
  vec4 s1 = floor(b1)*2.0 + 1.0;
  vec4 sh = -step(h, vec4(0.0));
  vec4 a0 = b0.xzyw + s0.xzyw*sh.xxyy ;
  vec4 a1 = b1.xzyw + s1.xzyw*sh.zzww ;
  vec3 p0 = vec3(a0.xy,h.x);
  vec3 p1 = vec3(a0.zw,h.y);
  vec3 p2 = vec3(a1.xy,h.z);
  vec3 p3 = vec3(a1.zw,h.w);
  vec4 norm = taylorInvSqrt(vec4(dot(p0,p0), dot(p1,p1), dot(p2, p2), dot(p3,p3)));
  p0 *= norm.x; p1 *= norm.y; p2 *= norm.z; p3 *= norm.w;
  vec4 m = max(0.6 - vec4(dot(x0,x0), dot(x1,x1), dot(x2,x2), dot(x3,x3)), 0.0);
  m = m * m;
  return 42.0 * dot( m*m, vec4( dot(p0,x0), dot(p1,x1),
                                dot(p2,x2), dot(p3,x3) ) );
}`,
          blend: `// glsl-blend (subset)
vec3 blendNormal(vec3 base, vec3 blend) { return blend; }
vec3 blendNormal(vec3 base, vec3 blend, float opacity) { return (blendNormal(base, blend) * opacity + base * (1.0 - opacity)); }
float blendLinearBurn(float base, float blend) { return max(base+blend-1.0,0.0); }
vec3 blendLinearBurn(vec3 base, vec3 blend) { return max(base+blend-vec3(1.0),vec3(0.0)); }
float blendLinearDodge(float base, float blend) { return min(base+blend,1.0); }
vec3 blendLinearDodge(vec3 base, vec3 blend) { return min(base+blend,vec3(1.0)); }
float blendLinearLight(float base, float blend) { return blend<0.5?blendLinearBurn(base,(2.0*blend)):blendLinearDodge(base,(2.0*(blend-0.5))); }
vec3 blendLinearLight(vec3 base, vec3 blend) { return vec3(blendLinearLight(base.r,blend.r),blendLinearLight(base.g,blend.g),blendLinearLight(base.b,blend.b)); }`,
          fragment: `varying vec3 v_color;
void main() {
  vec3 color = v_color;
  if (u_darken_top == 1.0) {
    vec2 st = gl_FragCoord.xy / resolution.xy;
    color.g -= pow(st.y + sin(-12.0) * st.x, u_shadow_power) * 0.4;
  }
  gl_FragColor = vec4(color, 1.0);
}`,
        };

        this.conf = {
          presetName: "",
          wireframe: false,
          density: [0.06, 0.16],
          zoom: 1,
          rotation: 0,
          playing: true,
        };

        if (document.querySelectorAll("canvas").length < 1) {
          console.log("DID NOT LOAD HERO STRIPE CANVAS");
          return;
        }

        this.minigl = new MiniGl(this.el, null, null, true);
        requestAnimationFrame(() => {
          if (this.el) {
            this.computedCanvasStyle = getComputedStyle(this.el);
            this.waitForCssVars();
          }
        });
      }
      disconnect() {
        if (this.scrollObserver) {
          window.removeEventListener("scroll", this.handleScroll);
          window.removeEventListener("mousedown", this.handleMouseDown);
          window.removeEventListener("mouseup", this.handleMouseUp);
          if (this.handleKeyDown) {
            window.removeEventListener("keydown", this.handleKeyDown);
          }
          this.scrollObserver.disconnect();
        }
        window.removeEventListener("resize", this.resize);
      }
      initMaterial() {
        this.uniforms = {
          u_time: new this.minigl.Uniform({ value: 0 }),
          u_shadow_power: new this.minigl.Uniform({ value: 5 }),
          u_darken_top: new this.minigl.Uniform({
            value: this.el.dataset.jsDarkenTop === "" ? 1 : 0,
          }),
          u_active_colors: new this.minigl.Uniform({
            value: this.activeColors,
            type: "vec4",
          }),
          u_global: new this.minigl.Uniform({
            value: {
              noiseFreq: new this.minigl.Uniform({
                value: [this.freqX, this.freqY],
                type: "vec2",
              }),
              noiseSpeed: new this.minigl.Uniform({ value: 5e-6 }),
            },
            type: "struct",
          }),
          u_vertDeform: new this.minigl.Uniform({
            value: {
              incline: new this.minigl.Uniform({
                value: Math.sin(this.angle) / Math.cos(this.angle),
              }),
              offsetTop: new this.minigl.Uniform({ value: -0.5 }),
              offsetBottom: new this.minigl.Uniform({ value: -0.5 }),
              noiseFreq: new this.minigl.Uniform({
                value: [3, 4],
                type: "vec2",
              }),
              noiseAmp: new this.minigl.Uniform({ value: this.amp }),
              noiseSpeed: new this.minigl.Uniform({ value: 10 }),
              noiseFlow: new this.minigl.Uniform({ value: 3 }),
              noiseSeed: new this.minigl.Uniform({ value: this.seed }),
            },
            type: "struct",
            excludeFrom: "fragment",
          }),
          u_baseColor: new this.minigl.Uniform({
            value: this.sectionColors[0],
            type: "vec3",
            excludeFrom: "fragment",
          }),
          u_waveLayers: new this.minigl.Uniform({
            value: [],
            excludeFrom: "fragment",
            type: "array",
          }),
        };

        for (let e = 1; e < this.sectionColors.length; e += 1) {
          this.uniforms.u_waveLayers.value.push(
            new this.minigl.Uniform({
              value: {
                color: new this.minigl.Uniform({
                  value: this.sectionColors[e],
                  type: "vec3",
                }),
                noiseFreq: new this.minigl.Uniform({
                  value: [
                    2 + e / this.sectionColors.length,
                    3 + e / this.sectionColors.length,
                  ],
                  type: "vec2",
                }),
                noiseSpeed: new this.minigl.Uniform({ value: 11 + 0.3 * e }),
                noiseFlow: new this.minigl.Uniform({ value: 6.5 + 0.3 * e }),
                noiseSeed: new this.minigl.Uniform({
                  value: this.seed + 10 * e,
                }),
                noiseFloor: new this.minigl.Uniform({ value: 0.1 }),
                noiseCeil: new this.minigl.Uniform({ value: 0.63 + 0.07 * e }),
              },
              type: "struct",
            })
          );
        }

        this.vertexShader = [
          this.shaderFiles.noise,
          this.shaderFiles.blend,
          this.shaderFiles.vertex,
        ].join("\n\n");

        return new this.minigl.Material(
          this.vertexShader,
          this.shaderFiles.fragment,
          this.uniforms
        );
      }
      initMesh() {
        this.material = this.initMaterial();
        this.geometry = new this.minigl.PlaneGeometry();
        this.mesh = new this.minigl.Mesh(this.geometry, this.material);
      }
      shouldSkipFrame(e) {
        return (
          !!window.document.hidden ||
          !this.conf.playing ||
          parseInt(e, 10) % 2 === 0 ||
          void 0
        );
      }
      updateFrequency(e) {
        this.freqX += e;
        this.freqY += e;
      }
      toggleColor(index) {
        this.activeColors[index] = this.activeColors[index] === 0 ? 1 : 0;
      }
      showGradientLegend() {
        if (this.width > this.minWidth) {
          this.isGradientLegendVisible = true;
          document.body.classList.add("isGradientLegendVisible");
        }
      }
      hideGradientLegend() {
        this.isGradientLegendVisible = false;
        document.body.classList.remove("isGradientLegendVisible");
      }
      init() {
        this.initGradientColors();
        this.initMesh();
        this.resize();
        requestAnimationFrame(this.animate);
        window.addEventListener("resize", this.resize);
      }
      waitForCssVars() {
        if (
          this.computedCanvasStyle &&
          this.computedCanvasStyle
            .getPropertyValue("--gradient-color-1")
            .indexOf("#") !== -1
        ) {
          this.init();
          this.addIsLoadedClass();
        } else {
          this.cssVarRetries += 1;
          if (this.cssVarRetries > this.maxCssVarRetries) {
            this.sectionColors = [16711680, 16711680, 16711935, 65280, 255];
            this.init();
            return;
          }
          requestAnimationFrame(() => this.waitForCssVars());
        }
      }
      initGradientColors() {
        this.sectionColors = [
          "--gradient-color-1",
          "--gradient-color-2",
          "--gradient-color-3",
          "--gradient-color-4",
        ]
          .map((cssPropertyName) => {
            let hex = this.computedCanvasStyle
              .getPropertyValue(cssPropertyName)
              .trim();
            if (hex.length === 4) {
              const hexTemp = hex
                .substr(1)
                .split("")
                .map((c) => c + c)
                .join("");
              hex = `#${hexTemp}`;
            }
            return hex && `0x${hex.substr(1)}`;
          })
          .filter(Boolean)
          .map(normalizeColor);
      }
    }

    // Init gradient on mount
    const gradient = new Gradient();
    gradient.initGradient("#gradient-canvas");

    // Cleanup on unmount
    return () => {
      gradient.pause();
      gradient.disconnect?.();
    };
  }, []);

  const currentCycle = imageCycles[cycleIndex];
  const previousCycle =
    imageCycles[cycleIndex === 0 ? imageCycles.length - 1 : cycleIndex - 1];

  // CHANGED: Non-first slots par main image ALWAYS current (no flash)
  const getMainBgImg = () =>
    firstOfPhase
      ? imgStage >= 1
        ? currentCycle.mainImg
        : previousCycle.mainImg
      : currentCycle.mainImg; // ✅ next slots: no previous image ever

  // CHANGED: center badge source ko gate se control (jab tak gate false hai, element hidden rahega)
  const getCenterBadgeImg = () =>
    centerGate ? currentCycle.centerIcon : previousCycle.centerIcon;

  const mainBgImg = getMainBgImg();
  const centerBadgeImg = getCenterBadgeImg();
  const currentButtonImg = buttonForCycle[cycleIndex];

  // progressive tint for non-active slots
  const slotBgByDistance = (dist) => {
    const steps = [
      "linear-gradient(180deg, #88C3CB  0%, #51929D 100%)",
      "linear-gradient(180deg, #A5D6DC 0%, #69AAB3 100%)",
      "linear-gradient(180deg, #C1E7EC 0%, #8FC5CC 100%)",
      "linear-gradient(180deg, #DDF3F6 0%, #BCE0E4 100%)",
    ];
    return steps[Math.min(Math.max(dist - 1, 0), steps.length - 1)];
  };
  const slotStyle = (i) =>
    i === selectedSlot
      ? {}
      : { background: slotBgByDistance(Math.abs(i - selectedSlot) || 1) };

  // jump to a slot
  const jumpTo = (phaseIdx, slotIdx) => {
    setSelectedPhase(phaseIdx);
    setSelectedSlot(slotIdx);
    setCycleIndex(phaseIdx * PHASE_SIZE + slotIdx);
  };

  return (
    <section className="py-4 position-relative" style={{ overflow: "hidden" }}>
      {/* <canvas id="gradient-canvas" data-js-darken-top=""></canvas> */}
      <canvas
        id="gradient-canvas"
        style={{
          "--gradient-color-1": "#CFE8FF", // lighter version of #9EC9FF
          "--gradient-color-2": "#E3F2FF", // softer wash, replaces #cbe2fdff
          "--gradient-color-3": "#F2FAFF", // ultra light sky-blue tint
          "--gradient-color-4": "#FFFFFF", // pure light wash
        }}
      />

      <div
        className="px-5 x-xxl-5 px-6 mx-auto position-relative"
        style={{
          maxWidth: "88%",
          height: "820px",
          zIndex: 1,
          borderRadius: "40px",
          boxSizing: "border-box",
        }}
      >
        <div className="frame-shift">
          <header
            className={`hero-head-once ${headRevealed ? "revealed" : ""}`}
            style={{ textAlign: "center" }}
          >
            {/* <h1
              style={{
                margin: 0,
                lineHeight: 1.15,
                letterSpacing: "-0.02em",
                color: "#242121ff",
                fontWeight: 700,
                fontSize: "3.6rem",
                fontFamily: "Inter",
              }}
            >
              Grow Your Business on
              <span
                style={{
                  color: "#1DB954",
                  fontFamily: "Inter",
                  fontWeight: 700,
                }}
              >
                {" "}
                WhatsApp
              </span>
            </h1> */}
            <h1
              style={{
                margin: 0,
                lineHeight: 1.15,
                letterSpacing: "-0.02em",
                color: "#242121ff",
                fontWeight: 700,
                fontSize: "3.6rem",
                fontFamily: "Inter",
              }}
            >
              <span className="h1-line1">Grow Your</span>{" "}
              <span className="h1-line2">Business</span>{" "}
              <span className="h1-line3">
                on&nbsp;
                <span className="h1-wa"
                  style={{
                    color: "#1DB954",
                    fontFamily: "Inter",
                    fontWeight: 700
                  }}
                >
                  WhatsApp
                </span>
              </span>
            </h1>

            <p
              style={{
                margin: "4px auto 0",
                color: "#413e3eff",
                fontSize: "1.1rem",
                maxWidth: 800,
                fontFamily: "Poppins",
                fontWeight: 300,
                textAlign: "center",
                lineHeight: 1.2,
              }}
            >
              Automate workflows, boost engagement and scale faster with
              <span
                style={{
                  fontSize: "1.1rem",
                  color: "#646363ff",
                  fontWeight: 550,
                  fontFamily: "Poppins",
                }}
              >
                {" "}
                AI-powered chatflows
              </span>
            </p>

            <div className="d-flex gap-3 mt-3 flex-wrap justify-content-center">
              <div className="btn-animated-border">
                <button className="btn-inner" aria-label="Get started">
                  Get started
                </button>
              </div>
            </div>

            {/* main container */}
            <div className="hero-art-container" aria-hidden="true">
              {/* LEFT: time slots */}
              <div className={`time-card slide-in ${showSides ? "show" : ""}`}>
                <div
                  className="phase-tabs"
                  role="tablist"
                  aria-label="Day phases"
                >
                  <button
                    className={`phase-tab ${selectedPhase === 0 ? "active" : ""
                      }`}
                    onClick={() => jumpTo(0, 0)}
                    role="tab"
                    aria-selected={selectedPhase === 0}
                  >
                    Morning
                  </button>
                  <button
                    className={`phase-tab ${selectedPhase === 1 ? "active" : ""
                      }`}
                    onClick={() => jumpTo(1, 0)}
                    role="tab"
                    aria-selected={selectedPhase === 1}
                  >
                    Afternoon
                  </button>
                  <button
                    className={`phase-tab ${selectedPhase === 2 ? "active" : ""
                      }`}
                    onClick={() => jumpTo(2, 0)}
                    role="tab"
                    aria-selected={selectedPhase === 2}
                  >
                    Evening
                  </button>
                </div>

                <div className="time-group">
                  <div className="time-slots vertical">
                    {currentPhase.slots.map((hh, i) => (
                      <div
                        key={`${currentPhase.name}-${hh}`}
                        className={`time-slot ${selectedSlot === i ? "active" : ""
                          }`}
                        onClick={() => jumpTo(selectedPhase, i)}
                        role="button"
                        title={`Go to ${hh}:00 ${currentPhase.period}`}
                        style={slotStyle(i)}
                      >
                        <span className="time-label">
                          {hh}:00 {currentPhase.period}
                        </span>
                        <img
                          className="slot-icon"
                          src={phaseIcons[selectedPhase]}
                          alt=""
                        />
                      </div>
                    ))}
                  </div>
                </div>
              </div>

              {/* RIGHT image + overlay content */}
              <div className={`right-card slide-in ${showSides ? "show" : ""}`}>
                <img
                  src={rightImg}
                  alt=""
                  className="right-side-img"
                  aria-hidden="true"
                />

                <div className="right-overlay-panel">
                  <h3 className="right-title">
                    The numbers prove the <br />future of engagement
                  </h3>

                  <div className="right-stats">
                    <div className="rrow">
                      <div className="rcopy">
                        <div className="rval">3Bn+</div>
                        <div className="rsub-1">
                          people use WhatsApp every month, making it the world’s
                          largest messaging platform.
                        </div>
                      </div>
                    </div>

                    <div className="rrow">
                      <div className="rcopy">
                        <div className="rval">98%</div>
                        <div className="rsub-2">
                          business messages on <br />WhatsApp are opened, far <br />higher
                          than email or SMS.
                        </div>
                      </div>
                    </div>

                    <div className="rrow">
                      <div className="rcopy">
                        <div className="rval">78%</div>
                        <div className="rsub-3">
                          of Indians prefer WhatsApp for customer support,
                          making it <br />the most trusted channel.
                        </div>
                      </div>
                    </div>

                    <div className="rrow">
                      <div className="rcopy">
                        <div className="rval">₹30</div>
                        <div className="rsub-4">
                          average customer acquisition <br />cost, one of the lowest
                          among other channels.
                        </div>
                      </div>
                    </div>

                    <div className="rrow">
                      <div className="rcopy">
                        <div className="rval">
                          90 <span style={{ fontSize: "16px" }}>sec</span>
                        </div>
                        <div className="rsub-5">
                          is the average response time, enabling fast and
                          real-time interactions.
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/* IMAGE section */}
              <div className={`hero-art slide-in ${showSides ? "show" : ""}`}>
                {/* image1 (main background) */}
                <img
                  src={mainBgImg}
                  alt=""
                  className={`card-back anim ${imgStage >= 1 ? "show" : ""} ${hbMain ? "hb-x" : ""
                    }`}
                />

                {/* image2 (phone) */}
                <img
                  src={heroImg2}
                  alt="Hero visual"
                  className={`card-front anim ${imgStage >= 2 ? "show" : ""} ${hbFront ? "hb-x" : ""
                    }`}
                />

                {/* layers 5 → 4 → 3 for the first cycle, then stay */}
                <img
                  src={heroImg3}
                  alt=""
                  className={`badge-back-left anim ${imgStage >= 6 ? "show" : ""
                    } ${hbL3 ? "hb-y" : ""}`}
                />
                <img
                  src={heroImg4}
                  alt=""
                  className={`badge-back-right anim ${imgStage >= 5 ? "show" : ""
                    } ${hbL4 ? "hb-y" : ""}`}
                />
                <img
                  src={heroImg5}
                  alt=""
                  className={`badge-front-right anim ${imgStage >= 4 ? "show" : ""
                    } ${hbL5 ? "hb-y" : ""}`}
                />

                {/* CHANGED: center badge — show gated by centerGate */}
                <img
                  src={centerBadgeImg}
                  alt=""
                  className={`badge-front-center anim ${centerGate ? "show" : ""
                    } ${hbCenter ? "hb-xy" : ""}`}
                />

                {/* CHANGED: button under center badge — show gated by centerGate */}
                <img
                  src={currentButtonImg}
                  alt=""
                  className={`badge-action-btn anim ${centerGate ? "show" : ""
                    }`}
                />
              </div>
            </div>
          </header>
        </div>
      </div>

      {/* === styles === */}
      <style>{`
        .frame-shift{ position:relative; top:20px; }
        @media (max-width:576px){ .frame-shift{ top:24px; } }

        .btn-animated-border{ position:relative; display:inline-block; padding:1px; border-radius:12px; overflow:hidden; }
        .btn-animated-border::before{ content:""; position:absolute; inset:0; background:conic-gradient(from 0deg,#4FC3FF,#00E785,#4FC3FF); animation:spin 4s linear infinite; }
        .btn-animated-border::after{ content:""; position:absolute; inset:2px; background: #fff; border-radius:10px; }
        .btn-inner{ 
            position:relative; 
            z-index:1; 
            padding:12px 20px; 
            border:none; 
            border-radius:10px; 
            background: conic-gradient(from 0deg, #073349ff, #13b870ff, #096fa3ff);
           -webkit-background-clip: text;
            background-clip: text;
            color: transparent;
           -webkit-text-fill-color: transparent;
            font-family: Poppins; 
            font-size:18px; 
            font-weight:500; 
            cursor:pointer; 
            line-height:1.2;
         }
        @keyframes spin{ 0%{ transform:rotate(50deg); } 100%{ transform:rotate(360deg); } }

        .hero-head-once{ opacity:0; transform:translateY(-16px); transition:all .6s ease; }
        .hero-head-once.revealed{ opacity:1; transform:translateY(0); }

        .hero-art-container{ 
          display:flex;  
          justify-content:center; 
          align-items:center; 
          width:100%; 
          margin:70px auto 0; 
          position:relative; 
        }

        .slide-in{ opacity:0; transform:translateY(-18px); transition:opacity .6s ease, transform .6s ease; }
        .slide-in.show{ opacity:1; transform:translateY(0); }

        /********************************************************************************************************/
        /* LEFT card */
      
.time-card{
  position:absolute; 
  left:-12.1rem; 
  top:0.9rem; 
  transform:translateY(-50%);
  min-width:360px; 
  min-height:200px; 
  padding:14px 14px; 
  z-index:2;

  border-radius:4px 14px 2px 40px;
  font-family:'Outfit',system-ui,-apple-system,Segoe UI,Roboto,Inter,sans-serif;
  position:relative; 
  overflow:hidden;

  /* ==== glassmorphism skin ==== */
  
  background: rgba(131, 119, 119, 0.18);             
  border: 1.4px solid rgba(255, 255, 255, 1);        
  backdrop-filter: blur(20px) saturate(180%);
  -webkit-backdrop-filter: blur(20px) saturate(180%);

  /* distinct floating effect */
  box-shadow: 0 12px 40px rgba(0,0,0,0.20), 
              inset 0 1px 2px rgba(255, 255, 255, 0.39); 
}

/* soft inner highlight like reference */
.time-card::before{
  content:"";
  position:absolute; inset:0; border-radius:inherit;
  background: linear-gradient(180deg,
               rgba(255,255,255,0.55) 0%,
               rgba(255,255,255,0.25) 100%);
  pointer-events:none;
}

        .phase-tabs{
          display:grid; 
          grid-template-columns:repeat(3,1fr);
          gap:10px; 
          align-items:center; 
          margin-bottom:14px;
        }
        .phase-tab{
          width:100%; 
          padding: 8px 12px;
          border-radius:10px; 
          cursor:pointer; 
          transition:all .25s ease;
          background:linear-gradient(180deg, rgba(255, 255, 255, 1), rgba(255,255,255,.28));
          box-shadow:inset 0 1px 0 rgba(255,255,255,.6), 0 6px 18px rgba(16,24,40,.12);
          backdrop-filter:blur(10px) saturate(130%); -webkit-backdrop-filter:blur(10px) saturate(130%);
          color: #2c3e50; 
          font-size:20px; 
          font-family:Poppins;
          font-weight:580; 
          text-align:center;
        }

        .phase-tab:not(.active){ font-weight: 400; }
        .phase-tab:hover{ transform:translateY(-1px); box-shadow:0 8px 18px rgba(5,78,145,.18); }
        
        .phase-tab.active{
          
          background:linear-gradient(180deg, #78cad7ff 0%, #296C76 100%); 
          color:#fff; 
          border-color:transparent;
          box-shadow:0 8px 20px rgba(5,78,145,.28);
        }

        .time-group{ position:relative; }
        .time-group::before{
          content:""; position:absolute; inset:0;
          background:radial-gradient(120px 60px at 18% 10%, rgba(255,255,255,.55), transparent 65%),
                     radial-gradient(160px 120px at 90% 120%, rgba(255,255,255,.18), transparent 70%);
          pointer-events:none; border-radius:inherit;
        }
        .time-slots.vertical{ display:flex; flex-direction:column; align-items:stretch; gap:12px; margin-left:0; }
        .time-slots.vertical .time-slot{
          display:flex; align-items:center; justify-content:space-between;
          width:100%; min-height:68px; padding:18px 18px; border-radius:12px;
          background:linear-gradient(180deg, #e0eefdff 0%, #c5dcf6ff 100%);
          border:1px solid rgba(255,255,255,.85);
          backdrop-filter:blur(10px) saturate(130%); -webkit-backdrop-filter:blur(10px) saturate(130%);
          cursor:pointer; transition:all .28s ease;
        }
        .time-slots.vertical .time-slot:hover{
          transform:translateY(-2px); box-shadow:0 10px 24px rgba(5,78,145,.18);
          background:linear-gradient(135deg, #e9f2ff, #f7fbff);
        }
        .time-slots.vertical .time-label{ 
          font-weight:700; 
          font-size:22px; 
          letter-spacing:.5px; 
          color: #2c3e50; 
          line-height:1; 
          font-family: Oxanium;        
        }
        .time-slots.vertical .time-slot.active{
          background:linear-gradient(180deg, #296C76 0%, #296C76 100%); 
          color:#fff;
        }
        .time-slots.vertical .time-slot.active .time-label{ color:#fff !important; font-weight:700; }
        .time-slots.vertical .time-slot:not(.active) .time-label{ color:#4b637cff; opacity:.85; font-weight:400; }
        .time-slots.vertical .time-slot:not(.active):hover .time-label{ color:#2c3e50; opacity:1; }
        .slot-icon{ width:30px; height:30px; flex:0 0 30px; filter:drop-shadow(0 1px 2px rgba(0,0,0,.15)); opacity:.95; }
        .time-slots.vertical .time-slot.active .slot-icon{ filter:brightness(1.8) drop-shadow(0 1px 2px rgba(0,0,0,.25)); }

        /********************************************************************************************************/
        .right-card{
          position:absolute;
          right:-4.9rem;
          top: 5.8rem;
          transform:translateY(-50%);
          width:430px;
          border-radius:14px 14px 40px 2px;
          overflow:hidden;
          z-index:2;
        }
        .right-card .right-side-img{
          position:static !important;
          right:auto; 
          top:auto; 
          transform:none !important;
          display:block; 
          width:90%; 
          max-width: 400px;
          max-height:600px;
          height:auto;
          border-radius:0;
          // object-fit:cover;
          
        }


        @media (max-width:768px){ .right-card{ display:none; } }
        .right-overlay-panel{ position:absolute; left:12px; right:12px; top:12px; border-radius:14px; padding:12px 12px 12px; color:#0f172a; }
        .right-title{ 
            margin-left: 3.4rem; 
            margin-top: -0.6rem; 
            font-family: Poppins; 
            text-align: center; 
            color: #2c3e50; 
            font-size: 20px; 
            line-height:1.3; 
            letter-spacing:-0.01em; 
            font-weight:600; 
        }
        .right-stats{ display:flex; flex-direction:column; gap:2px; }
        .rrow{ 
           display:flex;  
           align-items:flex-start; 
           border-radius:12px; 
           padding:10px 12px;
         }
        .rcopy{ display:flex; gap:2px; }
        .rval{ 
           font-weight:600; 
           font-size:20px; 
           font-family: Poppins; 
           line-height:1.1; 
           color:#2c3e50; 
           text-align:left; 
           margin-top:.10rem; 
           white-space:nowrap; 
           margin-left:1rem;
         }
        .rsub-1,.rsub-2,.rsub-3,.rsub-4,.rsub-5{ 
             font-size:15px; 
             font-family: Poppins; 
             color: #DDF3F6; 
             line-height:1.3;
             text-align:left; 
             max-width:400px;
             
         }
        .rsub-1{ margin-left: 1.4rem; } .rsub-2{ margin-left:2rem; } .rsub-3{ margin-left: 2.1rem; } .rsub-4{ margin-left: 2.3rem; } .rsub-5{ margin-left: 1rem; }

        /* Image section */
        .hero-art{ 
           position:relative; 
           width:100%; 
           max-width:470px; 
           height:620px;
           margin-right:40rem;
        }
        .hero-art img{ position:absolute; display:block; user-select:none; -webkit-user-drag:none; }
        .card-back{ left:56%; transform:translateX(-50%); bottom:180px; width:370px; opacity:.9; }
        .card-front{ left:108%; transform:translateX(-50%); bottom:10px; width:365px; border-radius:12px; }

        .badge-back-left { width:100px; left:calc(47% - 190px); top:calc(48% - 140px - 240px); }
        .badge-back-right{ width:100px; left:calc(-12% + 80px); top:calc(145% - 140px - 380px); }
        .badge-front-right{ width:100px; left:calc(122% + 50px); top:calc(67% - (-15px) - 320px); }

        .badge-front-center{ width:50%; left:109%; top:calc(90% - 180px); transform:translate(-50%,-50%); }
        .badge-action-btn{ width:240px; left:110%; top:calc(93% - 180px + 125px); transform:translate(-50%,-50%); z-index:3; }

        @media (max-width:576px){
          .hero-art-container{ margin:50px auto 0; }
          .hero-art{ max-width:90%; height:200px; }
          .card-back{ width:62%; bottom:70px; }
          .card-front{ left:64%; width:62%; bottom:8px; }
          .badge-back-left,.badge-back-right,.badge-front-right{ width:56px; }
          .badge-back-left{ left:calc(50% - 150px); top:calc(100% - 70px - 160px); }
          .badge-back-right{ left:calc(50% + 120px); top:calc(100% - 70px - 190px); }
          .badge-front-right{ left:calc(64% + 70px); top:calc(100% - 8px - 200px); }
          .badge-front-center{ width:70px; left:64%; top:calc(100% - 110px); transform:translate(-50%,-50%); }
          .badge-action-btn{ width:90px; left:64%; top:calc(100% - 56px); }
        }

        /* Fade/pop base transitions */
        .anim{ opacity:0; --pop:scale(.86); --ty:10px; transition:opacity .45s ease, transform .45s cubic-bezier(.2,.7,.2,1); will-change:transform,opacity; }
        .card-back.anim{ transform:translateX(-50%) translateY(var(--ty)) var(--pop); --pop:scale(.78); transition-duration:.6s; transition-timing-function:cubic-bezier(.2,.7,.2,1); }
        .card-front.anim{ transform:translateX(-50%) translateY(var(--ty)) var(--pop); --pop:scale(.82); transition-duration:.4s; transition-timing-function:cubic-bezier(.2,.7,.2,1); }
        .badge-front-center.anim,.badge-action-btn.anim{ transform:translate(-50%,-50%) translateY(var(--ty)) var(--pop); --pop:scale(.82); transition-duration:.4s; transition-timing-function:cubic-bezier(.2,.7,.2,1); }
        .badge-back-left.anim,.badge-back-right.anim,.badge-front-right.anim{ transform:translateY(var(--ty)) var(--pop); --pop:scale(.84); transition-duration:.5s; transition-timing-function:cubic-bezier(.2,.7,.2,1); }
        .anim.show{ opacity:1; --pop:scale(1); --ty:0px; }

        /* Spring heartbeat (bounce) */
        @keyframes hbX {
          0%   { transform: translateX(-50%) translateY(0) scale(0.94); }
          35%  { transform: translateX(-50%) translateY(0) scale(1.12); }
          55%  { transform: translateX(-50%) translateY(0) scale(0.97); }
          75%  { transform: translateX(-50%) translateY(0) scale(1.04); }
          100% { transform: translateX(-50%) translateY(0) scale(1); }
        }
        @keyframes hbXY {
          0%   { transform: translate(-50%, -50%) scale(0.94); }
          35%  { transform: translate(-50%, -50%) scale(1.12); }
          55%  { transform: translate(-50%, -50%) scale(0.97); }
          75%  { transform: translate(-50%, -50%) scale(1.04); }
          100% { transform: translate(-50%, -50%) scale(1); }
        }
        @keyframes hbY {
          0%   { transform: translateY(0) scale(0.94); }
          35%  { transform: translateY(0) scale(1.12); }
          55%  { transform: translateY(0) scale(0.97); }
          75%  { transform: translateY(0) scale(1.04); }
          100% { transform: translateY(0) scale(1); }
        }
        .hb-x  { animation: hbX  .6s cubic-bezier(.2,.8,.2,1) both; }
        .hb-xy { animation: hbXY .6s cubic-bezier(.2,.8,.2,1) both; }
        .hb-y  { animation: hbY  .6s cubic-bezier(.2,.8,.2,1) both; }

        /* === Left time-card sizing tweaks === */
        .time-card{ 
            width:340px; 
            min-width:340px; 
            min-height:170px; 
            padding:14px 14px; 
            left:-3.5rem; 
            top:4.8rem; 
            border-radius:12px 12px 12px 12px;
         }
        .phase-tabs{ gap:10px; }
        .phase-tab{ padding:8px 10px; font-size:18px; height:var(--tab-h); line-height:var(--tab-h); display:flex; align-items:center; justify-content:center; white-space:nowrap; }
        .time-slots.vertical{ gap:10px; }
        .time-slots.vertical .time-slot{ min-height:56px; padding:12px 14px; border-radius:12px; }
        .time-slots.vertical .time-label{ font-size:20px; letter-spacing:.3px; }
        .slot-icon{ width:30px; height:30px; }

        .time-card{ --tab-h:45px; --slot-h:56px; --slot-gap:10px; --slot-count:5; }
        .phase-tabs { align-items: stretch; }
        .time-group{ height: calc(var(--slot-count) * var(--slot-h) + (var(--slot-count) - 1) * var(--slot-gap)); }
        .time-slots.vertical{ height:100%; gap:var(--slot-gap); overflow:hidden; }
        .time-slots.vertical .time-slot{ min-height:var(--slot-h); height:var(--slot-h); display:flex; align-items:center; }

        /* Button no-heartbeat */
        .badge-action-btn.anim{ --pop:scale(1); transition-duration:.35s; }
        .badge-action-btn.hb-x,.badge-action-btn.hb-xy,.badge-action-btn.hb-y{ animation:none !important; }

        /* Background */
        section[aria-label="Hero"]{
          --tl-green: #d7fdd7ff; --bl-yellow: #eeddb6ff; --br-purple:#BFD9FF !important; --wash: #E9F1FF;
          background:
            radial-gradient(800px 560px at 50% 55%,
              rgba(255, 255, 255, 0) 0%,
              rgba(255, 255, 255, 0) 30%,
              rgba(255, 255, 255, 0) 45%,
              rgba(255,255,255,0) 58%),
            radial-gradient(ellipse 2000px 800px at 50% -12%,
              rgb(from var(--tl-green) r g b / .50) 0%,
              rgb(from var(--tl-green) r g b / .32) 40%,
              rgb(from var(--tl-green) r g b / .18) 65%,
              transparent 85%),
            radial-gradient(circle 900px at -10% -6%,
              rgb(from var(--tl-green) r g b / .45) 0%,
              rgb(from var(--tl-green) r g b / .28) 38%,
              rgb(from var(--tl-green) r g b / .12) 60%,
              transparent 80%),
            radial-gradient(circle 780px at -8% 120%,
              rgb(from var(--bl-yellow) r g b / .36) 0%,
              rgb(from var(--bl-yellow) r g b / .12) 48%,
              transparent 72%),
            radial-gradient(circle 820px at 106% 120%,
              rgb(from var(--br-purple) r g b / .36) 0%,
              rgb(from var(--br-purple) r g b / .18) 55%,
              transparent 80%),
            radial-gradient(ellipse 900px 320px at 30% 115%,
              rgb(from var(--bl-yellow) r g b / .16) 0%,
              rgb(from var(--bl-yellow) r g b / .10) 35%,
              transparent 70%),
            radial-gradient(ellipse 1400px 760px at 70% 110%,
              rgb(from var(--br-purple) r g b / .16) 0%,
              rgb(from var(--br-purple) r g b / .10) 35%,
              transparent 70%),
            radial-gradient(ellipse 900px 520px at 82% 96%,
              rgb(from var(--br-purple) r g b / .10) 0%,
              transparent 70%),
            linear-gradient(180deg, var(--wash) 0%, #FFFFFF 70%) !important;
          background-repeat: no-repeat;
          background-color: #FFFFFF;
        }

                /* === Global tokens (tweak these 4 and background updates everywhere) === */
:root{
  --heroC1: #DFF5FF;  /* very light blue */
  --heroC2: #FFFFFF;  /* base wash */
  --heroC3: #EAFBF1;  /* very light mint */
  --heroC4: #FFF6D6;  /* very light warm */
}
/* WebGL gradient canvas — now reads from the tokens above */
#gradient-canvas{
  width: 100%;
  height: 100%;
  /* feed MiniGL palette from tokens (super light) */
  --gradient-color-1: var(--heroC1);
  --gradient-color-2: var(--heroC2);
  --gradient-color-3: var(--heroC3);
  --gradient-color-4: var(--heroC4);

  z-index: 0;
  position: absolute;
  inset: 0;
}

/* (optional) ultra-light preset — just add the class to <body> or a wrapper if you ever want even lighter */
.hero-ultra-light{
  --heroC1: #FBF8FF;
  --heroC2: #FFFFFF;
  --heroC3: #F7FFFA;
  --heroC4: #FFFBEF;
}


/* mobile responsive.. */

@media (max-width: 576px) {
  .hero-head-once { 
     text-align: left !important; 
  }

  .hero-head-once .h1-line1,
  .hero-head-once .h1-line2,
  .hero-head-once .h1-line3 {
    display: block;  
    font-size: 3.2rem;  
    margin-top: -1.3rem;         
  }
  .hero-head-once h1 {
    font-size: 34px;         
    line-height: 1.12;
    margin: 0;
  }
  .hero-head-once .h1-line2 { 
     margin-top: 2px; 
  }

  .hero-head-once .h1-line3 { 
    margin-top: 2px; 
    white-space: nowrap;  
  }

  /* paragraph */
  .hero-head-once p {
    text-align: left !important;
    // font-size: 1.3rem;      
    line-height: 1.3;
  }

  /* keep CTA button centered on mobile */
  .hero-head-once .d-flex {
    justify-content: center !important;
  }
}


      `}</style>
    </section>
  );
};

export default HeroSection;

